import { Helmet } from 'react-helmet-async';
import ActivationsKeywordOther from 'src/sections/overview/dashboards/views/activations/keyword/other';

export default function BrandShieldKeywordsOther() {
  return (
    <>
      <Helmet>
        <title>Keywords (Other)</title>
      </Helmet>

      <ActivationsKeywordOther />
    </>
  );
}
